import React, { useState } from 'react';
import {
  Content,
  Page,
  Header,
} from '@backstage/core-components';
import {
  makeStyles,
  Tabs,
  Tab,
  Box,
} from '@material-ui/core';
import SmartToyIcon from '@material-ui/icons/Memory';
import FolderIcon from '@material-ui/icons/Folder';
import { AgentsList } from './AgentsList';
import { DocumentLibrary } from './DocumentLibrary';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
  tabPanel: {
    flex: 1,
    overflow: 'auto',
  },
}));

interface TabPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
}

function TabPanel({ value, index, children }: TabPanelProps) {
  if (value !== index) return null;
  return <Box>{children}</Box>;
}

export function GenaiBuilderPage() {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  return (
    <Page themeId="tool">
      <Header
        title="Agent Builder"
        subtitle="Create and manage AI agents, upload knowledge documents, and configure semantic search"
      />
      <Content>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Agents" icon={<SmartToyIcon />} />
          <Tab label="Document Library" icon={<FolderIcon />} />
        </Tabs>

        <Box className={classes.tabPanel}>
          <TabPanel value={tab} index={0}>
            <AgentsList />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <DocumentLibrary />
          </TabPanel>
        </Box>
      </Content>
    </Page>
  );
}
